import type { ObjectId } from '@racemap/sdk/schema/base';
import { useMonitorActions, useSelectedStarterId } from 'src/store/monitor_beta/monitorStore';
import { LocationTag } from '../BasicComponents/LocationTag/LocationTag';

export const AlertLocationTag = ({
  location,
  starterId,
}: {
  location?: { lat?: number; lng?: number };
  starterId?: ObjectId | null;
}) => {
  const selectedStarterId = useSelectedStarterId();
  const { flyTo, setSelectedStarterId } = useMonitorActions();

  const handleClick = async () => {
    if (location && (location.lat != null || location.lng != null)) {
      flyTo({
        center: [location.lng ?? 0, location.lat ?? 0],
        zoom: 14,
      });
    }
    if (starterId != null && !starterId.equals(selectedStarterId)) {
      await setSelectedStarterId(starterId.toString(), false);
    }
  };

  return <LocationTag location={location} onClick={handleClick} />;
};
